import { render, staticRenderFns } from "./TableAilment.vue?vue&type=template&id=755a21b8"
import script from "./TableAilment.vue?vue&type=script&lang=js"
export * from "./TableAilment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports